import { render, staticRenderFns } from "./FormPage.vue?vue&type=template&id=3327ff16&scoped=true&"
import script from "./FormPage.vue?vue&type=script&lang=js&"
export * from "./FormPage.vue?vue&type=script&lang=js&"
import style0 from "./FormPage.vue?vue&type=style&index=0&id=3327ff16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3327ff16",
  null
  
)

export default component.exports